import moment from 'moment';
import { getTimezoneOffsetInSeconds } from './index';
import { eachDayOfInterval, startOfDay, endOfDay } from 'date-fns';

export const getOffsetLabel = (offset) => {
  const hours = Math.floor(offset / 60);
  const minutes = offset % 60;

  return `${hours > 0 ? hours + 'h ' : ''}${minutes > 0 ? minutes + 'm' : ''}`.trim();
};

export const getNearestInterval = (time, interval) => {
  return moment(time || '00:00', 'HH:mm')
    .set({
      m: Math.ceil(moment(time, 'HH:mm').minutes() / interval) * interval,
    })
    .format('HH:mm');
};

export const getTodayStartEndDates = (timezone) => {
  const format = 'YYYY-MM-DDTHH:mm:ss.SSS';
  const end = moment.tz(moment(), timezone);
  const start = end.clone().startOf('day');

  const startDate = new Date(start.format(format)).getTime();
  const endDate = new Date(end.format(format)).getTime();

  return { startDate, endDate };
};

export const formatTimestamp = (timestamp, timezone, format = 'DD MMM • h:mm:ss A') => {
  return moment.tz(timestamp, timezone).format(format);
};

export const getTimeIntervalWithTimezone = (timeInterval, timezone) => {
  if (!timeInterval) {
    return undefined;
  }

  const offset = timezone ? moment().tz(timezone).utcOffset() : 0;
  const date = moment(`2024-01-01 ${timeInterval}`);
  return date.subtract(offset, 'minute').format('HH:mm');
};

export const getRangeDaysCount = (minDate, maxDate, daysOfWeek) => {
  const allDaysInRange = eachDayOfInterval({ start: startOfDay(minDate), end: endOfDay(maxDate) });
  return allDaysInRange.filter((day) => daysOfWeek.includes(day.getDay())).length;
};

export const isSpecificTimeInIntervalRange = (specificTime, timezone, intervalSec) => {
  const endInterval = moment.tz(moment(), timezone).format('HH:mm');
  const endIntervalSec = moment.duration(endInterval, 'HH:mm').asSeconds();
  const startIntervalSec = endIntervalSec - intervalSec;
  
  if (startIntervalSec < 0) {
    return false;
  }
  
  const startSpecificTimeSec = moment.duration(specificTime.start, 'HH:mm').asSeconds();
  const endSpecificTimeSec = moment.duration(specificTime.end, 'HH:mm').asSeconds();
  const isStartSTInRange = startIntervalSec <= startSpecificTimeSec && startSpecificTimeSec <= endIntervalSec;
  const isEndSTInRange = startIntervalSec <= endSpecificTimeSec && endSpecificTimeSec <= endIntervalSec;
  
  return isStartSTInRange && isEndSTInRange;
};
